// Brand + navigation constants for the temporary van Gelder site.
import { categories } from "../data/products";
import { ENVIRONMENTS } from "../data/solutions";

export const VG_ORANGE = "#ED8B00";
export const VG_ORANGE_DARK = "#C77400";
export const VG_CHARCOAL = "#777775";
export const VG_ACCENT = "#A9C8E8";

const CONTACT_TOPICS = [
  "General Questions",
  "Product Information",
  "Request a Quote",
  "Existing Order Help",
  "Customer Service",
  "Sales Support",
  "Sample Request",
];

const topicSlug = (t) => t.replace(/\s+/g, "-").toLowerCase();

// Nav items. `children` (optional) render as a dropdown menu.
export const CATALOG_PDF = "/docs/vG_Digital-Catalogue.pdf";

// Nav items. `children` (optional) render as a dropdown menu. `href` renders an
// external-style action link (opens PDF in a new tab and triggers a download).
export const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "Catalog", to: "/catalog" },
  {
    label: "About Us",
    to: "/about",
    children: [
      { label: "Company History", to: "/about" },
    ],
  },
  {
    label: "Products",
    to: "/products",
    children: categories.map((c) => ({
      label: c.name,
      to: `/products?category=${c.slug}`,
    })),
  },
  {
    label: "Solutions",
    to: "/solutions",
    children: ENVIRONMENTS.map((e) => ({
      label: e.name,
      to: `/solutions?env=${e.slug}`,
    })),
  },
  {
    label: "Resources",
    to: "/resources",
    children: [
      { label: "Resource Center", to: "/resources" },
      { label: "Entrance Defense", to: "/entrance-defense" },
    ],
  },
  {
    label: "Contact Us",
    to: "/contact",
  },
];

